import { useState, useEffect } from 'react';

const useSlider = (swiperRef) => {
  const [isEnd, setIsEnd] = useState(false);
  const [isBeginning, setIsBeginning] = useState(false);

  const checkBoundaries = () => {
    if (swiperRef.current) {
      setIsEnd(swiperRef.current.isEnd);
      setIsBeginning(swiperRef.current.isBeginning);
    }
  };

  const onInit = (swiper) => {
    swiperRef.current = swiper;
    checkBoundaries();
  };

  const handleDrag = () => {
    console.log('dragging');
    checkBoundaries();
  }

  const nextSlide = () => {
    swiperRef.current?.slideNext();
    checkBoundaries();
  };

  const prevSlide = () => {
    swiperRef.current?.slidePrev();
    checkBoundaries();
  };

  useEffect(() => {
    if (swiperRef.current) {
      checkBoundaries();
    }
  }, [swiperRef]);

  return {
    isEnd,
    isBeginning,
    nextSlide,
    prevSlide,
    checkBoundaries,
    onInit,
    handleDrag
  };
};

export default useSlider;
